

































import Vue from "vue";
import Tabs from "@/components/Tabs.vue";
import { BookingTemplateItem, BookingTemplateItemDimension as DimModel } from "../models/BookingTemplate";
import { t } from "@/plugins/i18n";

// Egy sablon-tétel 4–9. dimenzió-felosztásai, a K2D d_g_imboktranstemp_d tab-nézetének megfelelően
// (TransactionItemDimension minta). dimCodeType 5..10 = IV..IX. dimenzió. A dimenziók már a
// GetBookingTemplate válaszában benne vannak — nincs külön lekérés (a total itt arány, nem összeg).
interface TabDef {
  type: number;
  label: string;
}

interface Data {
  columns: any[];
  dimTabs: TabDef[];
}

interface Methods {
  dimsFor(type: number): DimModel[];
  typeLabel(type: number): string;
  formatTotal(v: number | null): string;
}

interface Props {
  item: BookingTemplateItem;
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "BookingTemplateItemDimension",

  components: { Tabs },

  props: {
    item: { type: Object as () => BookingTemplateItem, required: true },
  },

  data(): Data {
    return {
      columns: [
        { field: "dimCode", title: t("DimenzioKod"), cell: "codeTemplate" },
        { field: "dimCodeType", title: t("GeneralLedger_DimTipus"), width: "150px", cell: "typeTemplate" },
        { field: "total", title: t("GeneralLedger_Szorzo"), width: "160px", filterable: false, cell: "totalTemplate", className: "right_text" },
      ],
      // dimCodeType 5..10 → IV..IX. dimenzió (a dim száma = dimCodeType - 1).
      dimTabs: [
        { type: 5, label: t("IVDimenzio") },
        { type: 6, label: t("VDimenzio") },
        { type: 7, label: t("VIDimenzio") },
        { type: 8, label: t("VIIDimenzio") },
        { type: 9, label: t("VIIIDimenzio") },
        { type: 10, label: t("IXDimenzio") },
      ],
    };
  },

  mounted() {
    // Az első olyan fülre állunk, amelyen van adat (K2D: az első engedélyezett dimenzió).
    const idx = this.dimTabs.findIndex((t) => this.dimsFor(t.type).length > 0);
    const tab = this.$refs.tab as any;
    if (idx >= 0 && tab && tab.setTab) tab.setTab(idx);
  },

  methods: {
    dimsFor(type: number): DimModel[] {
      return (this.item.dimensions || []).filter((d) => d.dimCodeType === type);
    },

    // dimCodeType (5..10) -> "IV. dimenzió" ... felirat (a dim száma = dimCodeType - 1).
    typeLabel(type: number): string {
      const tab = this.dimTabs.find((t) => t.type === type);
      return tab ? tab.label : t("GeneralLedger_Dimenzio", [type - 1]);
    },

    formatTotal(v: number | null): string {
      if (v === null || v === undefined) return "";
      return Number(v).toFixed(3);
    },
  },
});
